import React from "react";
import "../Servicesmain/Servicesmain.css";
import Services from "../Services/Services";
import Serve from "./Serve";
import { Link } from "react-router-dom";
const Servicesmain = () => {
  return (
    <>
      <div className="about-us-s">
        <div className="overlay-a-s">
          <div className="text-container-s">
            <h1>Transform Your Space with Greenery</h1>
            <p>
              Discover the perfect plants to enhance your home decor. Let us
              help you bring your vision to life with our expert guidance and
              stunning selections.
            </p>
            <Link to="/contact">
              <button className="animated-button-s">Contact Us</button>
            </Link>
          </div>
        </div>
        <img src="serve2.webp" alt="About Us Poster" className="poster-image" />
      </div>
      <Serve />
      <Services />
    </>
  );
};

export default Servicesmain;
